/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adjusted_ByInputs */

const en_adjusted_by = /** @type {(inputs: Adjusted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjusted By`)
};

const es_adjusted_by = /** @type {(inputs: Adjusted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustado por`)
};

/**
* | output |
* | --- |
* | "Adjusted By" |
*
* @param {Adjusted_ByInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const adjusted_by = /** @type {((inputs?: Adjusted_ByInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adjusted_ByInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adjusted_by(inputs)
	return es_adjusted_by(inputs)
});